import { NgModule } from '@angular/core';
import { AlertModule } from '@pacifico/components/alert/alert.module';
import { SharedHeaderFooterModule } from '@pacifico/shared/shared-footer-header.module';
import { ContentAuthComponent } from './content-auth.component';

@NgModule({
	declarations: [ContentAuthComponent],
	imports: [SharedHeaderFooterModule, AlertModule],
	exports: [ContentAuthComponent]
})
export class ContentAuthModule {}
